export default "__VITE_ASSET__UTuzLZKU__"